/*
  inforgraphics.js

  A local plugin to place infographic images
  in the right place at the right time.

  Author: Tim Bauwens
*/

import { bb } from "$json";
import { getmetadata } from "$json/lib/getmetadata";

((doc, $) => {
  $(doc).on("bb:postHandleData", (e, data) => {
    if (data && data.groups && data.groups.length) {
      const props = getmetadata(data).props;
      if (props.has("p-infographics-img")) {
        const path = `../../rijks-cyberscan/plugins/infographics/live/images/${props.get(
          "p-infographics-img"
        )}`;
        const cssUrl = `url("${path}?v=20230117")`;
        doc
          .querySelector(".l-content--left--art")
          .style.setProperty("--artwork", cssUrl);
        bb.Mode.set("hasArt");
      } else {
        // remove old one.
        bb.Mode.unset("hasArt");
        doc
          .querySelector(".l-content--left--art")
          .style.setProperty("--artwork", "");
      }
    }
  });
})(document, jQuery);
